import { siteTagline, disclaimText } from '@/mocks/gossip';

const cols = [
  {
    title: '栏目导航',
    links: [
      { t: '今日热榜', h: '#hot' },
      { t: '五大栏目', h: '#topics' },
      { t: '最新瓜田', h: '#feed' },
      { t: '人物与幕后', h: '#network' },
      { t: '深度阅读', h: '#deep' },
    ],
  },
  {
    title: '吃瓜角度',
    links: [
      { t: '关联事件', h: '#topics' },
      { t: '同类型瓜', h: '#topics' },
      { t: '历史对比', h: '#topics' },
      { t: '人物关系', h: '#network' },
      { t: '幕后关联', h: '#network' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="mx-auto max-w-[1320px] px-4 md:px-6 py-12 md:py-16">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 font-brand text-xl text-foreground-950">
                瓜
              </span>
              <span className="font-heading text-xl md:text-2xl font-bold">吃瓜热点</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-7 text-background-50/75">{siteTagline}</p>
            <div className="mt-5 flex gap-2">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-bilibili-line', 'ri-rss-line'].map((c) => (
                <a
                  key={c}
                  href="mailto:hello@chigua-hotspot.example.com"
                  aria-label="关注我们"
                  className="flex h-10 w-10 items-center justify-center rounded-md border border-background-50/20 text-background-50/85 transition-colors hover:bg-accent-500 hover:text-foreground-950"
                >
                  <i className={`${c} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {cols.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <h4 className="font-heading text-sm font-bold tracking-wider text-accent-300">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.t}>
                    <a
                      href={l.h}
                      className="text-sm text-background-50/75 transition-colors hover:text-background-50 whitespace-nowrap"
                    >
                      {l.t}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold tracking-wider text-accent-300">关于本站</h4>
            <p className="mt-4 text-sm leading-7 text-background-50/75">{disclaimText}</p>
            <a
              href="mailto:hello@chigua-hotspot.example.com"
              className="mt-4 inline-flex items-center gap-2 rounded-md bg-background-50/10 px-4 py-2 text-sm font-semibold whitespace-nowrap transition-colors hover:bg-accent-500 hover:text-foreground-950"
            >
              <i className="ri-mail-send-line"></i>
              联系编辑部
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-50/15 pt-6 text-xs text-background-50/60 sm:flex-row">
          <p>© 2026 吃瓜热点 · 仅供信息聚合与延伸阅读</p>
          <p className="whitespace-nowrap">关联事件 · 同类型瓜 · 历史对比 · 人物关系 · 幕后关联</p>
        </div>
      </div>
    </footer>
  );
}